const variables = {
  desctop: 'min-width: 432px',
};

export default variables;
